// extracted by mini-css-extract-plugin
export default {"container":"RemoveAssignmentModal_container__cZxdf","buttonRow":"RemoveAssignmentModal_buttonRow__ajzL5"};